import React from "react";
import { Navigate } from "react-router-dom";

//QA Management

// //AuthenticationInner pages
// import BasicSignIn from "../pages/AuthenticationInner/Login/BasicSignIn";
// import CoverSignIn from "../pages/AuthenticationInner/Login/CoverSignIn";

//pages
// import SimplePage from "../pages/Pages/Profile/SimplePage/SimplePage";
// import Starter from "../pages/Pages/Starter/Starter";
// import Timeline from "../pages/Pages/Timeline/Timeline";

// import Alt404 from "../pages/AuthenticationInner/Errors/Alt404";
// import Basic404 from "../pages/AuthenticationInner/Errors/Basic404";
// import Cover404 from "../pages/AuthenticationInner/Errors/Cover404";
// import Error500 from "../pages/AuthenticationInner/Errors/Error500";
// import Offlinepage from "../pages/AuthenticationInner/Errors/Offlinepage";
// import BasicLogout from "../pages/AuthenticationInner/Logout/BasicLogout";
// import CoverLogout from "../pages/AuthenticationInner/Logout/CoverLogout";
import SiteMap from "../pages/Pages/SiteMap/SiteMap";

//login
import ForgetPasswordPage from "../pages/Authentication/ForgetPassword";
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";

// User Profile
import UserProfile from "../pages/Authentication/user-profile";

//Ssystem User
import SystemDisplay from "../pages/System Role/SystemDisplay";
import SystemEditor from "../pages/System Role/SystemEditor";
import SystemList from "../pages/System Role/SystemList";
//Management

import UserManageDisplay from "../pages/System Role/Usermanagement/UserManageDisplay";
import UserManageEditor from "../pages/System Role/Usermanagement/UserManageEditor";
import UserManageList from "../pages/System Role/Usermanagement/UserManageList";
import ResetPassword from "../pages/Authentication/ResetPassword";
import ChangePassword from "../pages/Authentication/ChangePassword";
import PasswordChange from "../pages/Authentication/PasswordChange";
import Registergetlist from "../pages/Authentication/Registergetlist";
import Rolesadminget from "../pages/Authentication/Rolesadminget";
import Logger from "../pages/Logger/Logger";
import LogDetail from "../pages/Logger/LogDetail";
import Aapiloglist from "../pages/Setting/apilog/Aapiloglist";
import AapilogDetail from "../pages/Setting/apilog/AapilogDetail";
import Requestloglist from "../pages/Setting/Request log/Requestloglist";
import RequestlogDetail from "../pages/Setting/Request log/RequestlogDetail";
import EmailLogList from "../pages/Pages/EmailLog/EmailLogList";
import EmailLogDetail from "../pages/Pages/EmailLog/EmailLogDetail";
import IncomingApiLogList from "../pages/Setting/IncomingApiLog/IncomingApiLogList";
import IncomingApiLogDetail from "../pages/Setting/IncomingApiLog/IncomingApiLogDetail";
import OrganizationManagement from "../QRCodeAdminPage/OrganizationManagement/Page/OrganizationManagement";
import MenuCategory from "../QRCodeAdminPage/MenuCategories/Page/MenuCategory";
import MenuItem from "../QRCodeAdminPage/MenuItem/page/MenuItem";
import LandingPage from "../QRCodeAdminPage/LandingPage/page/LandingPage";
import ViewProfile from "../QRCodeAdminPage/View Profile/Page/VIewProfile";
import UpdateProfile from "../QRCodeAdminPage/Update Profile/UpdateProfile";
import Register from "../pages/Authentication/Register";
import Verification from "../pages/Authentication/Verification";
import MenuItemDetail from "../QRCodeAdminPage/MenuItem/Component/MenuItemDetail";
import Theme from "../QRCodeAdminPage/ThemePage/page/Theme";
import ThemeDetail from "../QRCodeAdminPage/ThemePage/page/ThemeDetail";
import AddUpdateTheme from "../QRCodeAdminPage/ThemePage/Component/AddUpdateTheme";

import OrgPage from "../QRCodeCustomerPanel/Menu/Page/OrgPage";
import QrModal from "../QRCodeAdminPage/OrganizationManagement/Component/QrModal";
import DetailMenuCategory from "../QRCodeAdminPage/MenuCategories/Page/DetailMenuCategory";
import ContactMessage from "../QRCodeAdminPage/ContactMessage/ContactMessage";
import DetailMessage from "../QRCodeAdminPage/ContactMessage/DetailMessage";
import QrModalV2 from "../QRCodeAdminPage/OrganizationManagement/Component/QrMenuV2/QrModalV2";
import QRLanding from "../QRCodeCustomerPanel/QrLanding/QRLanding";
import Index from "../QRCodeCustomerPanel/Theme/Theme5/OnePage";
import DetailOrganization from "../QRCodeAdminPage/OrganizationManagement/Component/DetailOrganization";
import Dashboard from "../QRMenu/Dashboard";
import SettingPage from "../QRMenu/SettingPage";
import CheckOut from "../QRCodeCustomerPanel/Theme/DigitalMenuAI/Component/CheckOut";
import ReceivedOrder from "../QRCodeAdminPage/ReceivedOrder/page/ReceivedOrder";
import ReceivedOrderDetail from "../QRCodeAdminPage/ReceivedOrder/page/ReceivedOrderDetail";
import Currency from "../QRCodeAdminPage/Currency/Page/Currency";
import DetailCurrency from "../QRCodeAdminPage/Currency/Page/DetailCurrency";
import Unit from "../QRCodeAdminPage/Units/Page/Unit";
import DetailUnit from "../QRCodeAdminPage/Units/Page/DetailUnit";
import GeneralSettings from "../QRCodeAdminPage/GeneralSettings/page/GeneralSettings";
import { element } from "prop-types";
import { Theme9Menu } from "../QRCodeCustomerPanel/Theme/Theme9/Theme9Menu";
import { components } from "react-select";
import { QrSmallModal } from "../QRCodeAdminPage/OrganizationManagement/Component/QrMenuV2/QrSmallModal";
import { DiscountManagement } from "../QRCodeAdminPage/DiscountManagement/Page/DiscountManagement";
import { DiscountDetail } from "../QRCodeAdminPage/DiscountManagement/Page/DiscountDetail";
import { OrganizationUser } from "../QRCodeAdminPage/OrganizationUser/OrganizationUser";
import { OrgSitemap } from "../QRCodeAdminPage/Sitemap/OrgSitemap";
import { OrganizationPos } from "../QRCodeAdminPage/Organization POS/page/OrganizationPos";
import { OrgPos } from "../QRCodeAdminPage/POS/page/OrgPos";
import { TableManagement } from "../QRCodeAdminPage/TableManagement/TableManagement";
import { OrderTokenPage } from "../QRCodeAdminPage/POS/OrderToken/page/OrderTokenPage";

//i added
import Main from "../QRCodeAdminPage/CRUD/Main";
import GeneralAdminMain from "../QRCodeAdminPage/CRUD/generalAdmin/GeneralAdminMain";
import OrgDashboard from "../QRMenu/OrgDashBoard/OrgDashBoard";
import ExpenseHeadingList from "../QRCodeAdminPage/Expense Heading/Pages/ExpenseHeadingList";
import Purchase from "../QRCodeAdminPage/Purchase/page/Purchase";
import PurchaseDetail from "../QRCodeAdminPage/Purchase/Components/PurchaseDetail";
import ExpenseCategory from "../QRCodeAdminPage/Expense Category/ExpenseCategory";
import ExpenseTxnList from "../QRCodeAdminPage/Expense Detail/ExpenseTxnList";
import StockSummary from "../QRCodeAdminPage/StockSummary/StockSummary";
import PurchaseList from "../QRCodeAdminPage/Purchase List/PurchaseList";
import PurchaseEditor from "../QRCodeAdminPage/Purchase List/Components/PurchaseEditor";
import PurchaseDisplay from "../QRCodeAdminPage/Purchase List/Components/PurchaseDisplay";
import SalesReport from "../QRCodeAdminPage/SalesReport/SalesReport";
import { POSMobile } from "../QRCodeAdminPage/POS/POSMobile/POSMobile";
import PrintFlyer from "../QRCodeAdminPage/OrganizationManagement/Component/PrintFlyer/PrintFlyer";
import Top20Product from "../QRCodeAdminPage/LandingPage/page/Top20Product";
import SupplierList from "../QRCodeAdminPage/SupplierList/SupplierList";
import SupplierPurchased from "../QRCodeAdminPage/SupplierPurchased/SupplierPurchased";
import ItemWiseReport from "../QRCodeAdminPage/ItemWiseDetail/ItemWiseReport";
import BankList from "../QRCodeAdminPage/Bank/BankList";
import PaymentLog from "../QRCodeAdminPage/PaymentLog/PaymentLog";
import PaymentDetail from "../QRCodeAdminPage/PaymentLog/Components/PaymentDetail";
import BankStatement from "../QRCodeAdminPage/BankStatement/BankStatement";
import CounterCashTransaction from "../QRCodeAdminPage/CounterCashTransaction/CounterCashTransaction";
import Daybook from "../QRCodeAdminPage/Daybook/Daybook";
import CreditList from "../QRCodeAdminPage/Credit/CreditList";
import TenantOrganization from "../QRCodeAdminPage/OrganizationManagement/Page/Tenant/TenantOrganization";
//ApprovedList //asd



const authProtectedRoutes = [
  { path: "/home", component: <Navigate to="/project" /> },
  

  //i added//
  { path: "/list-users", component: <Main /> },
  { path: "/list-users-general-admin", component: <GeneralAdminMain /> },
  { path: "/print-flyer/:id", component: <PrintFlyer /> },
  { path: "/organization-pos-mobile", component: <POSMobile /> },
  {path: "/tenant", component: <TenantOrganization />},

  //i added//

  //Cosmos
  { path: "/dashboard", component: <Dashboard /> },

  //OrgDashboard
  { path: "/org-dashboard", component: <OrgDashboard /> },
  //Pages
  // { path: "/pages-starter", component: <Starter /> },
  // { path: "/pages-profile", component: <SimplePage /> },
  // // { path: "/pages-profile-settings",component:<Setting/>, component: <Settings /> },
  // { path: "/pages-timeline", component: <Timeline /> },

  //Outgoing Api log
  { path: "/api-log", component: <Aapiloglist /> },
  { path: "/api-log/:id", component: <AapilogDetail /> },

  //Incoming Api log
  { path: "/incoming-api-log", component: <IncomingApiLogList /> },
  { path: "/incoming-api-log/:id", component: <IncomingApiLogDetail /> },

  //Request log
  { path: "/request-log", component: <Requestloglist /> },
  { path: "/request-log/:id", component: <RequestlogDetail /> },

  //Email log
  { path: "/email-log", component: <EmailLogList /> },
  { path: "/email-log/:id", component: <EmailLogDetail /> },

  //System User
  { path: "/system-user", component: <SystemList /> },
  { path: "/system-user/create", component: <SystemEditor /> },
  { path: "/system-user/edit/:uuid", component: <SystemEditor /> },
  { path: "/system-user/details/:uuid", component: <SystemDisplay /> },
  //management
  { path: "/user-management", component: <UserManageList /> },
  { path: "/user-management/create", component: <UserManageEditor /> },
  { path: "/user-management/edit/:id", component: <UserManageEditor /> },
  { path: "/user-management/details/:uuid", component: <UserManageDisplay /> },

  //Logger
  { path: "/logger", component: <Logger /> },
  { path: "/logger/:id", component: <LogDetail /> },

  // Expense Heading
  { path: "/expense-heading", component: <ExpenseHeadingList /> },

  //User Profile
  { path: "/profile", component: <UserProfile /> },
  { path: "/Admin-roles", component: <Rolesadminget /> },
  { path: "/User-Role", component: <Registergetlist /> },
  { path: "/User-Role/create", component: <Register /> },
  { path: "/User-Role/edit/:id", component: <Register /> },
  // { path: "/Yup", component: <YupValidation /> },
  { path: "/change-password", component: <ChangePassword /> },

  { path: "/settings", component: <SettingPage /> },

  { path: "/organization-management", component: <OrganizationManagement /> },
  { path: "/discount-offer", component: <DiscountManagement /> },
  { path: "/discount-detail/:id", component: <DiscountDetail /> },
  { path: "/organization-user", component: <OrganizationUser /> },
  { path: "/menu-category", component: <MenuCategory /> },
  { path: "/menu-category/detail/:id", component: <DetailMenuCategory /> },
  { path: "/menu-item", component: <MenuItem /> },
  { path: "/organization/detail/:id", component: <DetailOrganization /> },
  { path: "/view-profile", component: <ViewProfile /> },
  { path: "/update-profile", component: <UpdateProfile /> },
  { path: "/update-profile/:id", component: <UpdateProfile /> },

  { path: "/menu-item/detail/:id", component: <MenuItemDetail /> },
  { path: "/theme", component: <Theme /> },
  { path: "/theme/detail/:id", component: <ThemeDetail /> },
  { path: "/theme/update/:id", component: <AddUpdateTheme /> },
  { path: "/theme/create", component: <AddUpdateTheme /> },

  { path: "/contact-message", component: <ContactMessage /> },
  { path: "/contact-message/detail/:id", component: <DetailMessage /> },

  //Purchase
  // { path: "/purchase", component: <Purchase /> },
  // { path: "/purchase/detail/:id", component: <PurchaseDetail /> },

  //Purchase List
  { path: "/purchase", component: <PurchaseList /> },
  { path: "/purchases/create", component: <PurchaseEditor /> },
  { path: "/purchases/edit/:id", component: <PurchaseEditor /> },
  { path: "/purchases/details/:id", component: <PurchaseDisplay /> },

  //Supplier
  { path: "/supplier", component: <SupplierList /> },

  { path: "/qr-code/:id", component: <QrModalV2 /> },
  { path: "/small-qr-code/:id", component: <QrSmallModal /> },
  { path: "/order-management", component: <ReceivedOrder /> },
  { path: "/order-management/detail/:id", component: <ReceivedOrderDetail /> },
  // {path:"/edit-order/:id", component: <EditOrderPage />},

  { path: "/table-management", component: <TableManagement /> },

  //Expense-Category
  { path: "/expense-category", component: <ExpenseCategory /> },

  //Expense-Detail
  { path: "/expense-detail", component: <ExpenseTxnList /> },

  //Payment-Log
  { path: "/supplier-payment-log", component: <PaymentLog /> },
  {path: "/invoice/:id", component: <PaymentDetail />},

  //Stock-Summary
  { path: "/stock-summary", component: <StockSummary /> },

  //credit-List
  { path: "/credit-list", component: <CreditList /> },

  //Sales-Report
  { path: "/sales-report", component: <SalesReport /> },

  //Supplier-Purchased-Reports
  { path: "/supplier-purchased-report", component: <SupplierPurchased /> },

  //Supplier-Purchased-Items
  { path: "/supplier-purchased-items", component: <ItemWiseReport /> },

  // Bank Statement
  { path: "/bank-statement", component: <BankStatement /> },

  //Counter Cash Transaction
  { path: "/counter-cash-transaction", component: <CounterCashTransaction /> },

  //daybook
  { path: "/daybook", component: <Daybook /> },


   //Bank
   { path: "/bank", component: <BankList /> },

  { path: "/currency", component: <Currency /> },
  { path: "/currency/detail/:id", component: <DetailCurrency /> },

  { path: "/unit", component: <Unit /> },
  { path: "/unit/detail/:id", component: <DetailUnit /> },

  { path: "/settings/general-settings", component: <GeneralSettings /> },



  

];

const publicRoutes = [
  { path: "/organization-sitemap", component: <OrgSitemap /> },
  { path: "/sitemap", component: <SiteMap /> },
  { path: "/theme-four", component: <Index /> },
  { path: "/organization-sales", component: <OrganizationPos /> },
  { path: "/organization-pos", component: <OrgPos /> },
  { path: "/order-token", component: <OrderTokenPage /> },
  // {path:"/organization-sales/order-page", component: <OrderPage />},
  // {path:"/order-detail/:id", component: <OrderDetail />},
  // {path : "/theme-six" , component: <ThemeHomeSix />},
  // {path:"/theme-six-menu", component: <ThemeMenuSix />},
  // {path:"/theme-six-contact", component: <ThemeContactSix />},
  // {path:"/theme-six-about", component: <ThemeAboutSix />},
  // {path: "/food-menu/:orgcode/:category",component:<Theme9Menu />},

  { path: "/", component: <LandingPage /> },
  { path: "/QR", component: <QRLanding /> },

  { path: "/top20", component: <Top20Product /> },

  // {
  //   path: "/:orgcode/food-menu",
  //   component: (
  //     <>
  //       <TenantStylesLoader />
  //       <FoodMenu />
  //     </>
  //   ),
  // },
  // {
  //   path: "/:orgcode/home",
  //   component: (
  //     <>
  //       <TenantStylesLoader />
  //       <Homes />
  //     </>
  //   ),
  // },
  // { path: "/:orgcode/about", component: <About /> },
  // { path: "/:orgcode/contact", component: <Contact /> },
  // { path: "/:orgcode/drinks-menu", component: <DrinksMenu /> },

  //theme bkt

  // { path: "/bhaktapur", component: <Menu /> },

  // Authentication Page
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  //{ path: "/forgot-password/:userName", component: <ForgetPasswordPage /> },
  { path: "/reset-password", component: <ResetPassword /> },

  { path: "/forgot-password-change", component: <PasswordChange /> },

  //AuthenticationInner pages
  // { path: "/auth-signin-basic", component: <BasicSignIn /> },
  // { path: "/auth-signin-cover", component: <CoverSignIn /> },
  // { path: "/auth-logout-basic", component: <BasicLogout /> },
  // { path: "/auth-logout-cover", component: <CoverLogout /> },
  // { path: "/auth-404-basic", component: <Basic404 /> },
  // { path: "/auth-404-cover", component: <Cover404 /> },
  // { path: "/auth-404-alt", component: <Alt404 /> },
  // { path: "/auth-500", component: <Error500 /> },
  // { path: "/auth-offline", component: <Offlinepage /> },

  { path: "/register", component: <Register /> },
  { path: "/validate-otp", component: <Verification /> },
  // {
  //   path: "/:orgcode",
  //   component: <OrgPage/>
  // },
  {
    path: "/:orgcode",
    component: <OrgPage />,
  },

  {
    path: "/:orgcode/checkout",
    component: <CheckOut />,
  },
  {
    path: "/:orgcode/:page",
    component: <OrgPage />,
  },
  {
    path: "/:orgcode/:page/:subPage",
    component: <OrgPage />,
  },
  {
    path: "*",
    component: <OrgPage />,
  },
  {
    path: "/qr",
    component: <QrModal />,
  },
];

export { authProtectedRoutes, publicRoutes };
